module.exports = __webpack_public_path__ + "img/library-news.35605226.jpg";